import $ from 'jquery';
const cancelButtonNodeName = 'CancelButtonText';

export const ButtonGenerator = {
	generateButtons(requirementsNodes: any, xmlData: Element, addCancelIfNeeded: boolean) {
		const buttonsRow = $('<div />').addClass('field').addClass('buttonsrow');
		const buttonsContainer = $('<div />').addClass('buttonscontainer').addClass('right');

		$.each(requirementsNodes, function (_index, node) {
			addButton(node, buttonsContainer);
		});

		if (addCancelIfNeeded) {
			addCancelButtonIfRequired(xmlData, buttonsContainer);
		}

		buttonsRow.append(buttonsContainer);

		return buttonsRow;
	},
};

function addButton(requirementsNode: any, buttonContainer: JQuery) {
	const buttonNode = generateButtonNode(
		requirementsNode.credential.id,
		requirementsNode.input.button
	);
	buttonContainer.append(buttonNode);
}

function generateButtonNode(credentialID: string, inputConstraint: string) {
	return $('<a />')
		.attr('id', credentialID)
		.attr('href', '#')
		.addClass('button') // For styling
		.addClass('forms-authentication-button') // For identifying generated buttons
		.text(inputConstraint);
}

function addCancelButtonIfRequired(xmlData: Element, rightDivNode: JQuery) {
	const cancelButton = generateCancelButtonNodeIfRequired(xmlData);
	if (cancelButton) {
		rightDivNode.append(cancelButton);
	}
}

function generateCancelButtonNodeIfRequired(xmlData: Element) {
	const cancelButtonNode = $(cancelButtonNodeName, xmlData);
	if (cancelButtonNode.length === 1) {
		return generateCancelButtonNode(cancelButtonNode.text());
	} else {
		return null;
	}
}

function generateCancelButtonNode(cancelButtonText: string) {
	return $('<a />')
		.attr('id', 'chimeraCancelBtn')
		.attr('href', '#')
		.addClass('button') // For styling
		.addClass('forms-authentication-button') // For identifying generated buttons
		.text(cancelButtonText);
}
